export default __webpack_public_path__ + "static/media/earrings_dark.c5391937.png";